/**
 * Cómo se juega, diseño con fotos (sections/chz-how-to-play.liquid): cada paso muestra una foto del juego.
 * - Tocar un paso cambia la foto y deja la sección quieta (manda la persona).
 * - Mientras la sección se ve y nadie la toca, avanza sola cada N segundos, con una barrita de avance.
 *   Con el puntero o el foco adentro se pausa; con movimiento reducido o pausado no avanza sola.
 * - Al cambiar de juego (pestañas de chz-channels) vuelve al primer paso.
 */
const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
const motionOff = () => document.documentElement.dataset.chzMotion === 'off';

/** @param {HTMLElement} panel */
function setup(panel) {
  if (panel.dataset.chzHowtoReady) return;
  const stage = panel.querySelector('[data-chz-howto-stage]');
  const buttons = /** @type {HTMLElement[]} */ ([...panel.querySelectorAll('[data-chz-howto-step]')]);
  if (!(stage instanceof HTMLElement) || !buttons.length) return;
  panel.dataset.chzHowtoReady = 'true';

  const photos = /** @type {HTMLElement[]} */ ([...stage.querySelectorAll('[data-chz-howto-photo]')]);
  const count = stage.querySelector('[data-chz-howto-count]');
  const seconds = parseFloat(getComputedStyle(stage).getPropertyValue('--chz-howto-interval')) || 4;
  let current = 0;
  let visible = false;
  let hovered = false;
  let manual = false;
  /** @type {number | undefined} */
  let timer;

  /** @param {number} index */
  const show = (index) => {
    current = index;
    const photo = photos.length ? index % photos.length : -1;
    photos.forEach((img, i) => img.classList.toggle('is-active', i === photo));
    buttons.forEach((button, i) => {
      button.setAttribute('aria-pressed', String(i === index));
      button.closest('li')?.classList.toggle('is-active', i === index);
    });
    if (count instanceof HTMLElement) {
      const label = count.dataset.label || '[paso]/[total]';
      count.textContent = label.replace('[paso]', String(index + 1)).replace('[total]', String(buttons.length));
    }
  };

  const schedule = () => {
    window.clearTimeout(timer);
    stage.classList.remove('is-playing');
    if (!visible || hovered || manual || panel.hidden || reduced.matches || motionOff() || buttons.length < 2) return;
    void stage.offsetWidth;
    stage.classList.add('is-playing');
    timer = window.setTimeout(() => {
      show((current + 1) % buttons.length);
      schedule();
    }, seconds * 1000);
  };

  buttons.forEach((button, i) =>
    button.addEventListener('click', () => {
      manual = true;
      show(i);
      schedule();
    })
  );

  panel.addEventListener('pointerenter', () => {
    hovered = true;
    schedule();
  });
  panel.addEventListener('pointerleave', () => {
    hovered = false;
    schedule();
  });
  panel.addEventListener('focusin', () => {
    hovered = true;
    schedule();
  });
  panel.addEventListener('focusout', () => {
    hovered = false;
    schedule();
  });

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      visible = Boolean(entry?.isIntersecting);
      schedule();
    }, { threshold: 0.35 }).observe(stage);
  }

  // Cambio de juego: el panel se muestra u oculta con el atributo hidden.
  new MutationObserver(() => {
    if (!panel.hidden) {
      manual = false;
      show(0);
    }
    schedule();
  }).observe(panel, { attributes: true, attributeFilter: ['hidden'] });

  show(0);
  stage.classList.add('is-ready');
}

function setupAll(scope = document) {
  for (const stage of scope.querySelectorAll('[data-chz-howto-stage]')) {
    const panel = stage.closest('.chz-howto__panel');
    if (panel instanceof HTMLElement) setup(panel);
  }
}

setupAll();
document.addEventListener('shopify:section:load', (event) => {
  if (event.target instanceof Element) setupAll(event.target);
});
